import { Endpoint } from "@eryxcoop/appyx-comm";
import DateAdapter from "../../adapters/DateAdapter";

export default class DashboardFiltersEndpoint extends Endpoint {
    adaptValues({ fromDate, toDate, channels, categories, withoutAllowances }) {
        const dateAdapter = new DateAdapter();
        return {
            from_date: dateAdapter.adapt(fromDate),
            to_date: dateAdapter.adapt(toDate),
            channels: (channels || []).join(","),
            categories: (categories || []).join(","),
            without_allowances: withoutAllowances,
        };
    }
}
